import { render, staticRenderFns } from "./EatIn.vue?vue&type=template&id=2b83507f"
import script from "./EatIn.vue?vue&type=script&lang=js"
export * from "./EatIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports